import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Panel} from 'react-bootstrap';


export default class TicketsCountBox extends React.Component{
    render(){
        return (
            <Panel className={'text-center'}>
                <h2>{this.props.count}</h2>
                <div className={'text-muted'}>
                    {this.props.description}
                </div>
            </Panel>
        );
    }
};